import { useApi } from '@/api';
import { SITE_SETTINGS_FETCH } from './action-types';
import { useTypedStore, type RootState } from '@/store';
import type { ActionContext } from 'vuex';
import type { SiteSettingsState } from './state';

export default {
  [SITE_SETTINGS_FETCH]: async ({ commit }: ActionContext<SiteSettingsState, RootState>) => {
    const store = useTypedStore();
    const api = useApi();

    if (store.getters['auth/adminAcl'].is_superuser
      || store.getters['auth/adminAcl'].teams.length) {
      const response = await api.getSiteSettings({});
      commit(SITE_SETTINGS_FETCH, response.data.payload);
    }
  },
};
